<template>
	<svg :width="width" :height="height" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="mask0_2777_7282" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="3" width="54"
			height="54">
			<path
				d="M30 55C33.2837 55.0043 36.5358 54.3596 39.5695 53.1029C42.6032 51.8463 45.3587 50.0025 47.6775 47.6775C50.0025 45.3587 51.8463 42.6032 53.1029 39.5695C54.3596 36.5358 55.0043 33.2837 55 30C55.0042 26.7164 54.3595 23.4643 53.1028 20.4306C51.8462 17.3969 50.0024 14.6414 47.6775 12.3225C45.3587 9.99756 42.6032 8.15377 39.5695 6.89713C36.5358 5.64049 33.2837 4.99577 30 5.00002C26.7164 4.99583 23.4643 5.64059 20.4306 6.89722C17.3969 8.15386 14.6414 9.99761 12.3225 12.3225C9.99761 14.6414 8.15386 17.3969 6.89722 20.4306C5.64059 23.4643 4.99583 26.7164 5.00002 30C4.99577 33.2837 5.64049 36.5358 6.89713 39.5695C8.15377 42.6032 9.99756 45.3587 12.3225 47.6775C14.6414 50.0024 17.3969 51.8462 20.4306 53.1028C23.4643 54.3595 26.7164 55.0042 30 55Z"
				fill="white" stroke="white" stroke-width="4" stroke-linejoin="round" />
			<path d="M20 30L27.5 37.5L42.5 22.5" stroke="black" stroke-width="4" stroke-linecap="round"
				stroke-linejoin="round" />
		</mask>
		<g mask="url(#mask0_2777_7282)">
			<path d="M0 0H60V60H0V0Z" :fill="color_prop" />
		</g>
	</svg>
</template>

<script>
export default {

	name: 'IconCheck',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '3.75rem', // "px" or "em" only
		},

		height_prop: {
			type: String,
			default: '3.75rem', // "px" or "em" only
		},

		color_prop: {
			type: String,
			default: '#4CAF50',
		}
	},

	data() {
		return {
		}
	},

	computed: {
		width() {
			// return Number(this.width_prop.substr(0, this.width_prop.length - 2)) * this.sizeMultiplier_prop + this.width_prop.substr(-2)
			const extracted = this.extractValueAndUnit(this.width_prop)
			return extracted.value * this.sizeMultiplier_prop + extracted.unit
		},

		height() {
			// return Number(this.height_prop.substr(0, this.height_prop.length - 2)) * this.sizeMultiplier_prop + this.height_prop.substr(-2)
			const extracted = this.extractValueAndUnit(this.height_prop)
			return extracted.value * this.sizeMultiplier_prop + extracted.unit
		},
	},

	methods: {
		// extract value and unit from a string. px, em, rem, %
		extractValueAndUnit(input) {
			const regex = /^([\d.]+)(px|em|rem|%)$/ // Matches numeric values with units
			const match = input.match(regex)

			if (match) {
				const value = parseFloat(match[1]) // Convert numeric part to a number
				const unit = match[2] // Extract unit part
				return { value, unit }
			}

			return { value: 0, unit: 'px' } // Default value
		}
	}
}
</script>

<style lang="css" scoped></style>